import { repositoryActions } from '../../services';

const failSafe = dispatch => ( entityName, promise ) =>
  promise.catch( err => dispatch( { type: repositoryActions( entityName ).FAILED, content: err } ) );

export const repositoryDispatcher = entityName => dispatch => ( {
  get( data ) {
    return failSafe( dispatch )( entityName, dispatch( { data, type: repositoryActions( entityName ).GET } )
      .then( response => dispatch( { item: response.data, type: repositoryActions( entityName ).SET } ) ) );
  },
  retrieve( data ) {
    return failSafe( dispatch )( entityName, dispatch( { data, type: repositoryActions( entityName ).RETRIEVE } )
      .then( response => dispatch( { items: response.data, type: repositoryActions( entityName ).RETRIEVED } ) ) );
  },
  remove( data ) {
    return failSafe( dispatch )( entityName, dispatch( { data, type: repositoryActions( entityName ).DELETE } )
      .then( response => dispatch( { item: data, type: repositoryActions( entityName ).DELETED } ) ) );
  },
  put( data ) {
    return failSafe( dispatch )( entityName, dispatch( { data, type: repositoryActions( entityName ).PUT } )
      .then( response => dispatch( { item: response.data, type: repositoryActions( entityName ).SET } ) ) );
  },
  clear() {
    return dispatch( dispatch )( { type: repositoryActions( entityName ).CLEAR } );
  }
} );